export default __webpack_public_path__ + "static/media/1484.66e39837.png";